import { useTranslation } from "react-i18next";

export default function StatsSection() {
  const { t } = useTranslation();

  const stats = [
    { num: t("home.stat1_num"), label: t("home.stat1_label"), icon: "ri-user-line" },
    { num: t("home.stat2_num"), label: t("home.stat2_label"), icon: "ri-server-line" },
    { num: t("home.stat3_num"), label: t("home.stat3_label"), icon: "ri-headphone-line" },
    { num: t("home.stat4_num"), label: t("home.stat4_label"), icon: "ri-flag-line" },
  ];

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Left Text */}
          <div className="flex-1">
            <span className="text-red-600 text-xs font-bold tracking-widest uppercase">{t("home.stats_label")}</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-3 mb-4 leading-tight">
              {t("home.stats_desc")}
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed max-w-md">
              Mail.net.az — Azərbaycan Respublikasının vətəndaşları üçün nəzərdə tutulmuş, müasir texnologiya üzərində qurulmuş etibarlı email platforması.
            </p>
          </div>

          {/* Right Stats Grid */}
          <div className="grid grid-cols-2 gap-6 flex-1">
            {stats.map((s, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 flex flex-col items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-red-50">
                  <i className={`${s.icon} text-red-600 text-lg`} />
                </div>
                <div>
                  <div className="text-3xl font-extrabold text-gray-900">{s.num}</div>
                  <div className="text-sm text-gray-500 mt-0.5">{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
